import { RootActionTypes, ThunkResult } from '../../../stores/types';
import { ActionTypes } from '../constants';

import createCenterQueryBuilder from './createCenterQueryBuilder';
import createShippingLane from './createShippingLane';

interface CreateCenterQueryBuilderAndShippingLaneOptions {
  organizationId: string;
  queryBuilderForm: io.flow.v0.unions.QueryBuilderForm;
  regionId: string;
  shippingConfigurationKey: string;
  shippingLaneDirection: io.flow.v0.enums.LaneDirection;
}

const createCenterQueryBuilderAndShippingLane = ({
  organizationId,
  queryBuilderForm,
  regionId,
  shippingConfigurationKey,
  shippingLaneDirection,
}: CreateCenterQueryBuilderAndShippingLaneOptions)
: ThunkResult<Promise<RootActionTypes>> => (
  dispatch,
) => dispatch(createCenterQueryBuilder(
  organizationId,
  queryBuilderForm,
)).then((result): Promise<RootActionTypes> => {
  if (result.type === ActionTypes.CREATE_CENTER_QUERY_BUILDER_FAILURE) {
    return Promise.resolve(result);
  }

  const queryBuilder = result.payload;
  const shippingLaneForm = { from: queryBuilder.q, to: regionId, direction: shippingLaneDirection };
  return dispatch(createShippingLane(
    organizationId,
    shippingConfigurationKey,
    shippingLaneForm,
  ));
});

export default createCenterQueryBuilderAndShippingLane;
